import { render, staticRenderFns } from "./IncomingMessages.vue?vue&type=template&id=8cb90b10"
import script from "./IncomingMessages.vue?vue&type=script&lang=js"
export * from "./IncomingMessages.vue?vue&type=script&lang=js"
import style0 from "./IncomingMessages.vue?vue&type=style&index=0&id=8cb90b10&prod&lang=scss"
import style1 from "./IncomingMessages.vue?vue&type=style&index=1&id=8cb90b10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports